module.exports = "/assets/data/44181461ac76308c430ea7279fb4f7f7-KT21.data.json";